import { graphql } from '@api/mesa'

export const GET_USER_INFO = graphql(`
  query GetUserInfo {
    getUserInfo {
      id
      firstName
      lastName
      email
      name
      nickname
      phoneNumber
      picture
      lastLogin
      createdAt
      updatedAt
      metadata {
        userTrackingFlag
      }
      cardInformation {
        lastFour
      }
      redeemedCardInviteCode
      referralCode
      sourcePartnerName
    }
  }
`)

export const CHECK_PHONE_NUMBER_IS_AVAILABLE = graphql(`
  query CheckPhoneNumberIsAvailable($phoneNumber: String!) {
    checkPhoneNumberIsAvailable(phoneNumber: $phoneNumber) {
      phoneNumberIsAvailable
    }
  }
`)
